import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { actions } from '../../../../../context';

const RefreshMappingsButton = () => {
    const dispatch = useDispatch();
    const isLoadingCodes = useSelector(
        (state) => state.daylight.isLoadingCodes
    );
    const clickHandler = () => {
        dispatch(actions.daylight.refreshCodes());
    };

    return (
        <Button
            color="info"
            onClick={() => clickHandler()}
            disabled={isLoadingCodes}>
            Refresh
            <FontAwesomeIcon
                icon={faRedoAlt}
                className="ml-2"
                spin={isLoadingCodes}
            />
        </Button>
    );
};

export default RefreshMappingsButton;
